import React from 'react'
import { Stamp, Tooltip } from './style'

export default ({ needTooltip = true, daInfo=false }) =>{

    const dataTestLabel = 'seal_superpreco'

    return (
        <Stamp daInfo={daInfo} data-test-component={dataTestLabel}>
            {needTooltip &&
                <Tooltip>
                    Alerta para grandes ofertas:
                    <br/>
                    este pode ser um ótimo negócio!
                </Tooltip>
            }
        </Stamp>
    )
}
